export enum ELanguage {
  En = 'en',
  Zh = 'zh',
}

/**
 * 一个 namespace 内的 key-value 翻译表
 */
export type INamespaceResource = Record<string, string>;

/**
 * 单个语言下的资源：
 * - 嵌套结构（推荐）: { common: {...}, apps: {...}, ... }
 * - 扁平结构（legacy）: { 'key1': 'value1', 'key2': 'value2', ... }
 */
export type ILanguageResource =
  | Record<string, INamespaceResource>
  | INamespaceResource;

export interface II18nInitOptions {
  defaultLanguage?: ELanguage;
  resources: Record<string, ILanguageResource>;
}
